export class CableCut {
  id: string;
  quantity: number;
  length: number;
  confirmed: boolean;
  bomLineId?: string;
  accountNumber: string;

  constructor(quantity?: number, length?: number) {
    this.quantity = quantity || 1;
    this.length = length || 1;
    this.confirmed = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/cable-cut.ts